module.exports = __webpack_public_path__ + "static/media/viewer.ce7fceb2.png";